export const BACKEND_URL =
  process.env.REACT_APP_ART_BACKEND_URL ??
  "https://colearn-art-api.sandbox-london-b.fetch-ai.com";
export const ENTROPY_FILL_RATE =
  process.env.REACT_APP_ENTROPY_FILL_RATE ?? 0.113;

export const EXPECTED_BLOCK_TIME = 13.2;
export const RESERVE_PRICE_DURATION = 25  // number of blocks price is const for at end

export const PLACEHOLDER_MODE: boolean = process.env.REACT_APP_PLACEHOLDER_MODE === "1";

export const NETWORK =
  process.env.REACT_APP_NETWORK ?? "unknown";
